module.exports = __webpack_public_path__ + "static/media/DEVOPS_PORJECT_1.0fda0e19.png";